import React from 'react'

export default class Featured extends React.Component {
  render() {
    return <article>Section: {this.props.match.params.section}</article>
  }
}



// WEBPACK FOOTER //
// ./src/components/Featured.js